import React from "react";
import logo from "../assets/pushapp-logo.png";

export const Logo = ({ className = "", onClick }) => {
  return (
    <button
      onClick={onClick}
      data-testid="brand-logo"
      className={`inline-flex items-center ${className}`}
      aria-label="PushApp home"
    >
      <img src={logo} alt="PushApp" className="h-9 w-auto sm:h-10" />
    </button>
  );
};
